import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'lodash';
import { fetchServiceKey } from '../../store/modules/servicekey';

const mapActionCreators = {
  fetchServiceKey,
};

const mapStateToProps = state => ({
  serviceKeys: state.serviceKey.serviceKeys,
  serviceTypes: state.serviceType.serviceTypes,
});

class ServiceKeyPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.default,
    };

    props.fetchServiceKey();
  }

  shouldComponentUpdate(nextProps, nextState) {
    let rerender = false;

    if (
      Object.keys(nextProps.serviceKeys).length !==
      Object.keys(this.props.serviceKeys).length
    ) {
      rerender = true;
    }

    if (
      Object.keys(nextProps.serviceTypes).length !==
      Object.keys(this.props.serviceTypes).length
    ) {
      rerender = true;
    }

    if (JSON.stringify(this.state.value) !== JSON.stringify(nextState.value)) {
      rerender = true;
    }

    return rerender;
  }

  setValue = value => {
    this.setState({ value });

    if (value !== null && typeof value.length !== 'undefined') {
      const vals = [];
      value.forEach(company => {
        vals.push(company.value);
      });

      this.props.onChange({
        target: {
          name: this.props.name,
          value: vals,
        },
      });
    } else {
      this.props.onChange({
        target: {
          name: this.props.name,
          value:
            value !== null && typeof value.value !== 'undefined'
              ? value.value
              : null,
        },
      });
    }
  };

  prepareSelectData = rawData => {
    const data = [];

    _.forOwn(rawData, item => {
      let serviceKeyName = '';

      if (typeof this.props.serviceKeys[item.service_key_id] !== 'undefined') {
        serviceKeyName = this.props.serviceKeys[item.service_key_id].name;
      }

      data.push({
        value: item.id,
        title: `${item.name} (${serviceKeyName})`,
        label: `${item.name} (${serviceKeyName})`,
        serviceKeyId: item.service_key_id,
      });
    });

    return _.sortBy(data, [
      object => {
        if (
          typeof this.props.serviceKeys[object.serviceKeyId] !== 'undefined'
        ) {
          return this.props.serviceKeys[object.serviceKeyId].name;
        } else {
          return '__';
        }
      },
      object => {
        return object.title;
      },
    ]);
  };

  render() {
    const placeholder = <span>Leistungsart wählen</span>;
    const selectData = this.prepareSelectData(this.props.serviceTypes);

    return (
      <div className="section">
        <Select
          onChange={this.setValue}
          options={selectData}
          placeholder={placeholder}
          multi={false}
          value={this.state.value}
          clearable
        />
      </div>
    );
  }
}
ServiceKeyPicker.propTypes = {
  name: PropTypes.string,
  default: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  fetchServiceKey: PropTypes.func,
  serviceTypes: PropTypes.object,
  serviceKeys: PropTypes.object,
};

ServiceKeyPicker.defaultProps = {
  serviceTypes: {},
  serviceKeys: {},
};

export default connect(mapStateToProps, mapActionCreators)(ServiceKeyPicker);



// WEBPACK FOOTER //
// ./src/components/ServiceKeyPicker/ServiceKeyPicker.js